import { flatListToHierarchical } from '@utils/flatListToHierarchical';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';

import '@css/disabled-link.css';
import '@css/footer-css.css';
import '@css/general-css.css';
import '@css/header-css.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const HeaderInr = () => {  
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    document.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const [isBurgerVisible, setIsBurgerVisible] = useState(true);
  const [isCloseVisible, setIsCloseVisible] = useState(false);

  const handleClick = () => {
    document.getElementById('bs-navbar').classList.toggle('slide-menu');
    document
      .getElementsByClassName('navbar-header')[0]
      .classList.toggle('active-menu');
    document.body.classList.toggle('m-menu-active');
    if (isBurgerVisible) {
      setIsBurgerVisible(false);
      setIsCloseVisible(true);
    } else {
      setIsBurgerVisible(true);
      setIsCloseVisible(false);
    }
  };

  const data = useStaticQuery(graphql`
    {
      wpMenu(locations: { eq: GATSBY_HEADER_MENU }) {
        menuItems {
          nodes {
            id
            label
            path
            parentId
          }
        }
      }
    }
  `);

  const { nodes } = data.wpMenu.menuItems;

  const menuItems = flatListToHierarchical(nodes);

  const [home, about, work, involvement, contact, donate] = menuItems;

  const districtPartnership = work.children[1];

  return (
    <header
      className={`header inner-page-head ${scrolled ? 'fixed-header' : ''}`}
    >
      <div className='container'>
        <div className='row'>
          <div className='col-sm-2 brand'>
            <Link to={home.path}>
              <StaticImage
                src='../images/world-savvy-logo-2.png'
                className='fixed-logo'
                alt='World Savvy Logo'
              />

              <StaticImage
                src='../images/world-savvy-logo-1.png'
                className='static-logo'
                alt='World Savvy Logo'
              />
            </Link>
          </div>
          <div className='col-sm-6 header-mid-col'>
            <nav className='navbar'>
              <div className='navbar-header'>
                <button onClick={handleClick} className='menu-btn'>
                  {isBurgerVisible && (
                    <svg
                      className='menu-open-btn'
                      width='32'
                      height='32'
                      viewBox='0 0 32 32'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M4 24H28'
                        stroke='white'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M4 16H28'
                        stroke='white'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M4 8H28'
                        stroke='white'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  )}
                  {isCloseVisible && (
                    <svg
                      className='close-m-btn'
                      width='26'
                      height='26'
                      viewBox='0 0 26 26'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M25 1L1 25'
                        stroke='#353735'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M1 1L25 25'
                        stroke='#353735'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  )}
                </button>
              </div>
              <div id='bs-navbar'>
                <div className='m-brand'>
                  <Link to={home.path}>
                    <StaticImage
                      src='../images/world-savvy-logo-2.png'
                      className='fixed-logo'
                      alt='World Savvy Logo'
                    />
                  </Link>
                </div>
                <ul className='nav navbar-nav'>
                  <li className='dropdown after-none'>
                    <Link to={home.path}>{home.label}</Link>
                  </li>
                  <li className='dropdown'>
                    <Link to={about.path}>{about.label}</Link>
                    <div className='megamenu-multilevel'>
                      <ul className='my-megamenu'>
                        <li>
                          <ul className='sub-menu'>
                            {about.children.map(item => (
                              <li key={item.id}>
                                <Link to={item.path}>{item.label}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className='dropdown'>
                    <Link to={work.path}>{work.label}</Link>
                    <div className='megamenu-multilevel'>
                      <ul className='my-megamenu'>
                        <li>
                          <ul className='sub-menu'>
                            <li key={work.children[0].id}>
                              <Link to={work.children[0].path}>
                                {work.children[0].label}
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`${districtPartnership.path}#district-partnerships`}
                              >
                                {districtPartnership.label}
                              </Link>
                            </li>
                            <li>
                              <ul className='sub-menu'>
                                {districtPartnership.children.map(item => (
                                  <li key={item.id}>
                                    <Link to={item.path}>{item.label}</Link>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li className='dropdown'>
                    <Link to={involvement.path}>{involvement.label}</Link>
                    <div className='megamenu-multilevel'>
                      <ul className='my-megamenu'>
                        <li>
                          <ul className='sub-menu'>
                            {involvement.children.map(item => (
                              <li key={item.id}>
                                <Link to={item.path}>{item.label}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li className='hide-desk'>
                    <Link to={contact.path} className='btn white-outline-btn'>
                      {contact.label}
                    </Link>
                  </li>
                  <li className='hide-desk'>
                    <Link to={donate.path} className='btn white-btn'>
                      {donate.label}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className='mega-footer'> </div>
            </nav>
          </div>
          <div className='col-sm-4 header-right-col hide-mobile'>

              <Link to={contact.path} className='btn white-outline-btn'>
                {contact.label}
              </Link>
            
            
              <Link to={donate.path} className='btn white-btn'>
                {donate.label}
              </Link>
      
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderInr;
